import { useI18n } from '../contexts/I18nContext';

export function useRelativeTime() {
  const { t } = useI18n();
  return (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return t('just_now');
    if (diff < 3600) return `${Math.floor(diff / 60)} ${t('min_ago')}`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} ${t('h_ago')}`;
    return `${Math.floor(diff / 86400)} ${t('d_ago')}`;
  };
}

export function formatDateTime(iso, lang = 'en') {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString(lang === 'lv' ? 'lv-LV' : 'en-GB', {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}

export function formatTime(iso, lang = 'en') {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleTimeString(lang === 'lv' ? 'lv-LV' : 'en-GB', { hour: '2-digit', minute: '2-digit' });
}
